import myaxios from "../../components/Axios";

export const getPrepareOrderService = () => myaxios.get(`/ajax/order/prepare`)
export const getSingleOrderService = ({ id, expand }: { id: number, expand: string }) => myaxios.get(`/ajax/order/${id}?expand=${expand}`)
export const createOrderService = ({ data }: { data: any }) => myaxios.post(`/ajax/order`, data)
export const updateOrderService = ({ id, data }: { id: number, data: any }) => myaxios.put(`/ajax/order/${id}`, data)
export const deleteOrderService = ({ id }: { id: number }) => myaxios.delete(`/ajax/order/${id}`)